import * as React from 'react';

function SvgCog(props) {
  return (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.962 5.72l-.766 1.277c.26.45.465.938.602 1.452l1.444.362a1 1 0 01.758.97v.438a1 1 0 01-.758.97l-1.444.361c-.128.48-.315.937-.55 1.362l.788 1.263a1 1 0 01-.13 1.224l-.304.316a1 1 0 01-1.219.171l-1.29-.743a5.961 5.961 0 01-1.543.655l-.36 1.444a1 1 0 01-.97.758h-.44a1 1 0 01-.97-.757l-.36-1.445a5.965 5.965 0 01-1.453-.602l-1.277.766a1 1 0 01-1.222-.15l-.31-.31a1 1 0 01-.15-1.222l.766-1.277a5.962 5.962 0 01-.602-1.452l-1.445-.362A1 1 0 012 10.22v-.438a1 1 0 01.757-.97l1.445-.362c.128-.48.314-.936.55-1.36l-.788-1.265A1 1 0 014.093 4.6l.304-.315a1 1 0 011.219-.172l1.291.745a5.966 5.966 0 011.542-.656l.362-1.445A1 1 0 019.78 2h.438a1 1 0 01.97.757l.361 1.445a5.963 5.963 0 011.453.602l1.277-.766a1 1 0 011.222.15l.31.31a1 1 0 01.15 1.222zm-7.686.122a4.5 4.5 0 113.449 8.316 4.5 4.5 0 01-3.45-8.316z"
        fill={props.color}
      />
    </svg>
  );
}

export default SvgCog;
